import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';
import '@viniciomendesr/rayrovisk-design-system/styles.css';
import './app.css';
import { App } from './App';
import { initAnalytics } from './analytics/posthog';

const analytics = initAnalytics();

/**
 * The provider is conditional because the client is. Mounting it around an
 * uninitialised singleton makes every `capture` in the app print an error at
 * the console instead of doing nothing, and a build with no token is the normal
 * case in development and in the whole test suite.
 *
 * `PostHogErrorBoundary` is deliberately absent: `App` opens with its own
 * boundary, so nothing ever reaches an outer one. That boundary reports to
 * PostHog itself.
 */
const tree = analytics ? (
  <PostHogProvider client={analytics}>
    <App />
  </PostHogProvider>
) : (
  <App />
);

createRoot(document.getElementById('root')!).render(<StrictMode>{tree}</StrictMode>);
